import React from "react";
import "./controles.css";
import {
  IcMas,
  IcMenos,
  IcPantallaCompleta,
} from "./player-components/IconosPlayer";

//herramientas de la vista: acercar, alejar y pantalla completa. Se muestran y ocultan al tocar el
//fondo (desplegarMenu); el botón de VR va aparte, siempre visible, en la misma columna
const MenuComponent = ({
  handleClickPlusButton,
  handleClickMinusButton,
  handleClickFullScreenButton,
  desplegarMenu,
}) => {
  const herramientas = [
    { clave: "acercar", titulo: "Acercar", Icono: IcMas, accion: handleClickPlusButton },
    { clave: "alejar", titulo: "Alejar", Icono: IcMenos, accion: handleClickMinusButton },
    {
      clave: "pantalla",
      titulo: "Pantalla completa",
      Icono: IcPantallaCompleta,
      accion: handleClickFullScreenButton,
    },
  ];

  return (
    <div
      id="menuFlotante"
      className={`seventh-step p360-grupo ${desplegarMenu ? "" : "p360-grupo--oculto"}`}
      role="toolbar"
      aria-label="Herramientas de la vista"
      aria-orientation="vertical"
    >
      {herramientas.map(({ clave, titulo, Icono, accion }) => (
        <button
          key={clave}
          type="button"
          className="p360-btn p360-vidrio"
          title={titulo}
          aria-label={titulo}
          tabIndex={desplegarMenu ? 0 : -1}
          onClick={() => accion && accion()}
        >
          <Icono />
        </button>
      ))}
    </div>
  );
};
export default MenuComponent;
